"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSegmentEnum = void 0;
/**
 * Признаки для сегментирования пользователей с целью выделения маркетинговых групп
 * (списков рассылок оповещений и прочее)
 */
var UserSegmentEnum;
(function (UserSegmentEnum) {
  /** захотел стать преподавателем */
  UserSegmentEnum[UserSegmentEnum["as_if_teacher"] = 1] = "as_if_teacher";
  /** использует мобильное приложение */
  UserSegmentEnum[UserSegmentEnum["use_mobile_app"] = 2] = "use_mobile_app";
  /** имеет верифицированный профиль преподавателя */
  UserSegmentEnum[UserSegmentEnum["has_verified_teacher_profile"] = 3] = "has_verified_teacher_profile";
  /** захотел стать учеником */
  UserSegmentEnum[UserSegmentEnum["as_if_student"] = 4] = "as_if_student";
  /** является основателем хотя бы одной школы */
  UserSegmentEnum[UserSegmentEnum["school_owner"] = 5] = "school_owner";
  /** является преподавателем хотя бы одной школы */
  UserSegmentEnum[UserSegmentEnum["school_teacher"] = 6] = "school_teacher";
  /** захотел стать методистом */
  UserSegmentEnum[UserSegmentEnum["as_if_methodist"] = 7] = "as_if_methodist";
  /** создавал контент */
  UserSegmentEnum[UserSegmentEnum["has_content"] = 20] = "has_content";
  /** есть опубликованный контент */
  UserSegmentEnum[UserSegmentEnum["has_pub_content"] = 21] = "has_pub_content";
  /** есть популярный контент */
  UserSegmentEnum[UserSegmentEnum["has_pop_content"] = 22] = "has_pop_content";
  /** создавал коллекции */
  UserSegmentEnum[UserSegmentEnum["has_collection"] = 23] = "has_collection";
  /** есть опубликованныые коллекции */
  UserSegmentEnum[UserSegmentEnum["has_pub_collection"] = 24] = "has_pub_collection";
  /** есть популярные коллекции */
  UserSegmentEnum[UserSegmentEnum["has_pop_collection"] = 25] = "has_pop_collection";
  /** продал хотя бы одну коллекцию */
  UserSegmentEnum[UserSegmentEnum["has_collection_sold"] = 26] = "has_collection_sold";
  /** пробовал создать митинг */
  UserSegmentEnum[UserSegmentEnum["tried_meeting"] = 30] = "tried_meeting";
  /** провёл митинг */
  UserSegmentEnum[UserSegmentEnum["provided_meeting"] = 31] = "provided_meeting";
  /** провёл несколько митингов */
  UserSegmentEnum[UserSegmentEnum["provided_many_meetings"] = 32] = "provided_many_meetings";
  /** приглашал кого-то на митинг */
  UserSegmentEnum[UserSegmentEnum["invited_to_meeting"] = 33] = "invited_to_meeting";
  /** есть услуги */
  UserSegmentEnum[UserSegmentEnum["has_user_services"] = 40] = "has_user_services";
  /** создал максимум индивидуальных занятий */
  UserSegmentEnum[UserSegmentEnum["has_max_user_services"] = 41] = "has_max_user_services";
  /** провёл индивидуальное занятие */
  UserSegmentEnum[UserSegmentEnum["provided_user_service"] = 42] = "provided_user_service";
  /** провёл много индивидуальных занятий */
  UserSegmentEnum[UserSegmentEnum["provided_many_user_service"] = 43] = "provided_many_user_service";
  /** Есть активная банковская карта */
  UserSegmentEnum[UserSegmentEnum["has_approved_bank_card"] = 44] = "has_approved_bank_card";
  /** Есть свободное время в календаре  */
  UserSegmentEnum[UserSegmentEnum["has_free_hours_30days"] = 45] = "has_free_hours_30days";
  /** Есть занятое время в календаре  */
  UserSegmentEnum[UserSegmentEnum["has_busy_hours_30days"] = 46] = "has_busy_hours_30days";
  /** Может принимать платежи: заполнен финансовый профиль и есть карта  */
  UserSegmentEnum[UserSegmentEnum["can_acceptance_payments"] = 47] = "can_acceptance_payments";
  /** Пропустил сегмент Расписание в анкете */
  UserSegmentEnum[UserSegmentEnum["skipped_schedule_segment_in_introducion_form"] = 48] = "skipped_schedule_segment_in_introducion_form";
  /** Пропустил сегмент Банковская карта в анкете */
  UserSegmentEnum[UserSegmentEnum["skipped_bank_card_segment_in_introducion_form"] = 49] = "skipped_bank_card_segment_in_introducion_form";
  /** Пропустил сегмент Приложение в анкете */
  UserSegmentEnum[UserSegmentEnum["skipped_mobile_app_segment_in_introducion_form"] = 50] = "skipped_mobile_app_segment_in_introducion_form";
  /** Сегмент "Ранее не работал" */
  UserSegmentEnum[UserSegmentEnum["has_doesnt_work_before_enabled"] = 51] = "has_doesnt_work_before_enabled";
  /** Пропустил сегмент Услуги в анкете */
  UserSegmentEnum[UserSegmentEnum["skipped_services_segment_in_introducion_form"] = 52] = "skipped_services_segment_in_introducion_form";
  /** есть опубликованые (одобренные, промодерированые) услуги */
  UserSegmentEnum[UserSegmentEnum["has_pub_user_services"] = 53] = "has_pub_user_services";
  /** есть популярные услуги */
  UserSegmentEnum[UserSegmentEnum["has_pop_user_services"] = 54] = "has_pop_user_services";
  /** Использует фиктивный биллинг */
  UserSegmentEnum[UserSegmentEnum["bypass_billing"] = 55] = "bypass_billing";
  /**
   * Маркетинговая акция с кодом 'promoA'
   * https://app.clickup.com/t/8693zu39f
   */
  UserSegmentEnum[UserSegmentEnum["promo_a_config"] = 56] = "promo_a_config";
  /**
   * Маркетинговая акция с кодом 'promoB'
   * https://app.clickup.com/t/8693zu39f
   */
  UserSegmentEnum[UserSegmentEnum["promo_b_config"] = 57] = "promo_b_config";
  /**
   * Маркетинговая акция с кодом 'promoC'
   * https://app.clickup.com/t/8693zu39f
   */
  UserSegmentEnum[UserSegmentEnum["promo_c_config"] = 58] = "promo_c_config";
  /**
   * Маркетинговая акция с кодом 'promoD'
   * https://app.clickup.com/t/8693zu39f
   */
  UserSegmentEnum[UserSegmentEnum["promo_d_config"] = 59] = "promo_d_config";
  // NOTE: для добавления пунктов - следующий пункт
  // 60
})(UserSegmentEnum = exports.UserSegmentEnum || (exports.UserSegmentEnum = {}));
